
export interface Client {
    name: string;
    logo: string;
    category: string[]
};

export interface Partner {
    name: string;
    logo: string;
    category: string[]
}

export const partners:Partner[] = [
    {
        name:"Kaspersky",
        logo: "/assets/expertises/kaspersky.png",
        category: [
            'software',
            'design',
            'software-engineering',
            'infrastructure'
        ]
    },
    {
        name: "Paloalto",
        logo: "/assets/partners/paloalto.png",
        category: [
            'software',
            'design',
            'software-engineering',
            'infrastructure'
        ]
    },
    {
        name: "Fortinet",
        logo: "/assets/expertises/Fortinet_logo.png",
        category: [
            'software',
            'design',
            'software-engineering',
            'infrastructure'
        ]
    },
    {
        name: "Microsoft",
        logo: "/assets/expertises/microsoft-logo.png",
        category: [
            'software',
            'design',
            'software-engineering',
            'infrastructure'
        ]
    },
    {
        name: "VMWare",
        logo: "/assets/expertises/vmware.png",
        category: [
            'software',
            'design',
            'software-engineering',
            'infrastructure'
        ]
    },
    {
        name: "Cisco",
        logo: "/assets/expertises/cisco-logo-12.png",
        category: [
            'software',
            'design',
            'software-engineering',
            'infrastructure'
        ]
    },
    {
        name: "WServers",
        logo: "/assets/expertises/wservers.png",
        category: [
            'software',
            'design',
            'software-engineering',
            'infrastructure'
        ]
    },
];

export const clients:Client[] = [
    {
        name: "Korione",
        logo: "/assets/clients/korione.png",
        category: [
            'software',
            'design',
            'software-engineering'
        ]
    },
    {
        name: "LBS",
        logo: "/assets/clients/lbs.png",
        category: [
            'software',
            'design',
            'software-engineering'
        ]
    },
    {
        name: "Ellios",
        logo: "/assets/clients/ellios.png",
        category: [
            'software',
            'design',
            'software-engineering'
        ]
    },
    {
        name: "Emrald Securities Services",
        logo: "/assets/clients/ess-logo.svg",
        category: [
            'software',
            'design',
            'software-engineering'
        ]
    },

]